// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1rnDu","header":"ReportDetails_header__TJXMP","title":"ReportDetails_title__1QfBJ","left":"ReportDetails_left__2EtW0"};